import Env from '../base/env'
import gsap from 'gsap'
import { ScrollTrigger } from "../vendor/gsap-bonus-umd/ScrollTrigger";
import { SplitText } from "../vendor/gsap-bonus-umd/SplitText";
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(SplitText);
import { part1Play,part1PlayAlt,part1Leave } from '../fx/Common'


export default class revealStep0
{
  constructor()
  {
    const view = document.querySelector('.story0')
    //? Dom
    this.DOM = {
      title: view.querySelector('.title'),
      subtitle: view.querySelector('.fxSubtitle'),
      intro: document.querySelector('.jsIntroTxt')
    }
    //? Set FX
    this.FX = {
      title:new SplitText(this.DOM.title, { type:"chars", charsClass:"txt-fx" }),
      intro:new SplitText(this.DOM.intro, { type:"chars", charsClass:"txt-fx" }),
    }
    // Timeout
    this.timeout = false
    //? Set timeline
    this.tl = gsap.timeline()
    this.tlPart2 = gsap.timeline()
  }

  destroy()
  {
    clearTimeout(this.timeout)
    gsap.set(this.FX.title.chars, { autoAlpha:0 })
    gsap.set(this.FX.intro.chars, { autoAlpha:0 })
  }

  play()
  {
    const timeout = (Env.initSite)?500:0;
    this.timeout = setTimeout(() => {
      setTimeout(() => {
        part1Play(this.tl,this.FX.title.chars)
      }, 400);
      part1PlayAlt(this.tlPart2,this.FX.intro.chars)


      gsap.fromTo(
        this.DOM.subtitle,
        {
          autoAlpha:0,
          scale:.6
        },
        {
          autoAlpha:1,
          scale:1,
          ease:'quint.out',
          duration:2,
          delay:.8
        }
      )
    }, timeout);

  }

  leave(cbStart=null,cbComplete=null)
  {
    const timeout = (Env.initSite)?500:0;
    clearTimeout(this.timeout)
    setTimeout(() => {
      gsap.killTweensOf(this.DOM.subtitle)
      part1Leave(this.tl,this.FX.title.chars,cbStart,cbComplete)
      part1Leave(this.tlPart2,this.FX.intro.chars,cbStart,cbComplete)

      gsap.to(
        this.DOM.subtitle,
        {
          autoAlpha:0,
          ease:'quint.out',
          duration:1
        }
      )
      Env.initSite = false
    },timeout)


  }
}
